
module.exports = Object.freeze({
    'nodeViews': 'nodeViews',
    'edgeViews': 'edgeViews', 
    'id': 'id',
    'position': 'position',
    's': 's',
    't': 't',
    'label': 'label', 
    'labelColor' : 'labelColor',
    'labelFontSize' : 'labelFontSize',
    'color': 'color',
    'size' : 'size',
    'width' : 'width',

    'preprocessColor': 'preprocessColor',
    'preprocessAlpha': 'preprocessAlpha',
    'preprocessLabelColor': 'preprocessLabelColor',
    'preprocessLabelAlpha': 'preprocessLabelAlpha',
    'preprocessNodeWidth' : 'preprocessNodeWidth',
    'preprocessNodeHeight' : 'preprocessNodeHeight'
});